import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgb-game-nav',
  standalone: true,
  imports: [CommonModule, FGBSharedModule],
  templateUrl: './game-nav.component.html',
  styleUrl: './game-nav.component.scss',
})
export class GameNavComponent implements AfterViewInit {
  @Input() selectedIndex = 0;
  @Input() minWidth: number | 'auto' = 'auto';
  @Input() tabs: string[] = [];
  @ViewChild('indicator', { static: true }) indicatorRef!: ElementRef;
  @ViewChild('tabsContainer', { static: true }) tabsContainerRef!: ElementRef;
  @Output() tabSelectionChange: EventEmitter<number> = new EventEmitter<number>();

  ngAfterViewInit(): void {
    this._init();
  }

  private _init(): void {
    this.tabSelectionChange.emit(this.selectedIndex);
  }

  selectTab(index: number, event?: MouseEvent): void {
    this.selectedIndex = index;
    this.tabSelectionChange.emit(this.selectedIndex);
  }

  get tabStyle(): { [key: string]: string } {
    return {
      minWidth: this.minWidth === 'auto' ? 'auto' : `${this.minWidth}px`,
    };
  }
}
